<div id="sidebar-background" class="fixed inset-0 bg-gray-500 bg-opacity-30 h-screen w-screen overflow-y-auto z-[100]">
    <div class="fixed inset-y-0 right-0 w-2/3 sm:w-1/5">
        <div #sidebarpanel class="flex flex-col justify-items-center p-3 gap-y-[1px] bg-ponder-light text-slate-50 rounded-lg shadow-xl h-full">
            <div class="flex flex-row gap-2 items-center">
                <avatar [username]="authSession!.username"></avatar>
                @if (authSession!.displayName) {
                    <div>
                        {{ authSession!.displayName! }}
                    </div>
                    <div class="text-faded-70">
                        ({{ authSession!.username! }})
                    </div>
                } @else {
                    <div>
                        {{ authSession!.username! }}
                    </div>
                }
            </div>

            <div class="bg-faded-10 w-full min-h-[1px] mt-3 mb-3"></div>

            <sidebar-profile></sidebar-profile>
            <sidebar-account></sidebar-account>
            <notification-bubble [display]="hasFriendsNotification">
                <sidebar-friends></sidebar-friends>
            </notification-bubble>
            
            <div class="bg-faded-10 w-full min-h-[1px] mt-3 mb-3"></div>

            <sidebar-collection></sidebar-collection>
            <sidebar-decks></sidebar-decks>
            <sidebar-lists></sidebar-lists>
            <sidebar-stats></sidebar-stats>
            <sidebar-history></sidebar-history>
            
            <div class="bg-faded-10 w-full min-h-[1px] mt-3 mb-3"></div>

            <sidebar-advanced-search></sidebar-advanced-search>
            <sidebar-news></sidebar-news>
            <!-- <sidebar-community></sidebar-community> -->
            <sidebar-support></sidebar-support>
            
            <div class="bg-faded-10 w-full min-h-[1px] mt-3 mb-3"></div>

            <sidebar-logout></sidebar-logout>
        </div>
    </div>
</div>